export default __webpack_public_path__ + "static/media/detail_big_14_5.f95bd28f.jpg";